import pro1 from "../assets/pro-1.PNG";
import pro2 from "../assets/pro-2.PNG";
import pro3 from "../assets/pro-3.PNG";
import pro4 from "../assets/pro-4.PNG";
import pro5 from "../assets/pro-5.PNG";
import pro6 from "../assets/pro-6.PNG";


const ProjectCardData = [
    {
        imgsrc: pro1,
        title: "Travel Website",
        text: "A travel website for trekking freaks around Kashmir created using HTML, CSS and React",
        source: "https://github.com/Moudisa/React_Website"
    },
    {
        imgsrc: pro2,
        title: "Shopping Web App",
        text: "An anime merchandise shopping web application created using Java, SQL, HTML/CSS & bit of Bootstrap.",
        source: "https://github.com/Moudisa/Shopping_Web_App"
    },
    {
        imgsrc: pro4,
        title: "Brain Champ",
        text: "A gaming desktop application that consists of numerous mind bending games created using Java, Java Swing API, JDBC, MySQL.",
        source: "https://github.com/Moudisa/Brain_Champ"
    },
    {
        imgsrc: pro3,
        title: "Solicitor Android App",
        text: "An android application created using Android Studio and Firebase. An informative portal exclusively for law professionals.",
        source: "https://github.com/Moudisa/Solicitor-AndroidApp"
    },
    {
        imgsrc: pro5,
        title: "Bak Bak",
        text: "An android chatting application created using Android Studio (Java, XML).",
        source: "https://github.com/Moudisa/BakBak"
    },
    {
        imgsrc: pro6,
        title: "Edu-Portal",
        text: "An informative educational portal for desktop users created using Java, JDBC, Swing API, MySQL.",
        source: "https://github.com/Moudisa/eduPortal"
    }
];

export default ProjectCardData;